import { render, staticRenderFns } from "./PageStructureHeader.vue?vue&type=template&id=5b0e9c9e&"
import script from "./PageStructureHeader.vue?vue&type=script&lang=ts&"
export * from "./PageStructureHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureHeader.vue?vue&type=style&index=0&id=5b0e9c9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports